const $ = jQuery;

/**
 * Universal method to update chat settings in the DOM and save via settings form submission.
 *
 * @param {string}  settingName  The name attribute of the input/select/textarea.
 * @param {any}     settingValue The new value to set.
 * @param {boolean} submitForm   Whether to submit the settings form after updating.
 * @returns {boolean} True if the setting was successfully processed, false otherwise.
 */
export function updateChatSettings(settingName, settingValue, submitForm = true) {
    const settingsForm = $('.chat-settings');
    if (!settingsForm.length) {
        return false;
    }

    const field = settingsForm.find(`[name="${settingName}"]`);
    if (!field.length) {
        return false;
    }

    let isChanged = false;

    // Handle select elements
    if (field.is('select')) {
        // If option exists, ensure it is enabled and visible
        const option = field.find(`option[value="${settingValue}"]`);
        if (option.length) {
            option.prop('disabled', false).show();
        }

        if (field.val() !== settingValue) {
            field.val(settingValue).trigger('change');
            if ($.fn.chosen) {
                field.trigger('chosen:updated');
            }
            isChanged = true;
        }
    }
    // Handle checkbox inputs
    else if (field.is(':checkbox')) {
        const checked = (settingValue === true || settingValue === 'on' || settingValue === 1 || settingValue === '1');
        if (field.prop('checked') !== checked) {
            field.prop('checked', checked).trigger('change');
            isChanged = true;
        }
    }
    // Handle radio buttons
    else if (field.is(':radio')) {
        const checkedRadio = settingsForm.find(`[name="${settingName}"][value="${settingValue}"]`);
        if (checkedRadio.length && !checkedRadio.prop('checked')) {
            checkedRadio.prop('checked', true).trigger('change');
            isChanged = true;
        }
    }
    // Handle text inputs, textareas, hidden inputs
    else {
        if (field.val() !== settingValue) {
            field.val(settingValue).trigger('change');
            isChanged = true;
        }
    }

    // Submit the settings form to persist changes in DB
    if (submitForm) {
        settingsForm.trigger('submit');
    }

    return true;
}

/**
 * Resolve the best available option value for a chat settings select field
 * from a priority-ordered list of candidates.
 *
 * Prefers the first candidate whose option exists and is not disabled.
 * Falls back to the first candidate that simply exists (even if disabled).
 * Returns an empty string if none of the candidates are found.
 *
 * @param {string}   settingName The name attribute of the select field.
 * @param {string[]} candidates  Priority-ordered list of option values to try.
 * @returns {string} The best matching option value, or '' if none found.
 */
export function resolveChatSettingOption(settingName, candidates = []) {
    const settingsForm = $('.chat-settings');
    if (!settingsForm.length) {
        return '';
    }

    const select = settingsForm.find(`select[name="${settingName}"]`);
    if (!select.length) {
        return '';
    }

    // First pass: prefer an option that exists and is not disabled
    for (const value of candidates) {
        const option = select.find(`option[value="${value}"]`);
        if (option.length && !option.is(':disabled')) {
            return value;
        }
    }

    // Second pass: fall back to any option that exists (even if disabled)
    for (const value of candidates) {
        if (select.find(`option[value="${value}"]`).length) {
            return value;
        }
    }

    return '';
}

